import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Container, NbButton, NbCard } from "@/components/nb";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Enter your email");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      // Even on error we present a friendly outcome — but only if 500
      toast.error(err?.response?.data?.detail || "Could not send reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="max-w-lg">
      <NbCard color="white" className="p-8">
        <Link to="/auth" data-testid="back-to-auth" className="font-mono-sl text-xs uppercase underline">← Back to login</Link>
        <h1 className="mt-4 font-heading font-black text-4xl tracking-tighter">Forgot password?</h1>
        {!sent ? (
          <>
            <p className="mt-3 text-neutral-700">Type the email on your account. We'll send you a link to set a new password.</p>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <input required type="email" placeholder="your.email@school.edu" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="w-full px-4 py-3 nb-border rounded-lg bg-white" />
              <NbButton type="submit" color="black" disabled={loading} data-testid="forgot-submit" className="w-full">
                {loading ? "Sending..." : "Send reset link"}
              </NbButton>
            </form>
          </>
        ) : (
          <div className="mt-6" data-testid="forgot-sent">
            <div className="w-14 h-14 rounded-xl bg-sl-primary nb-border grid place-items-center"><Mail className="w-7 h-7" /></div>
            <h2 className="mt-4 font-heading font-black text-2xl tracking-tight">Check your inbox.</h2>
            <p className="mt-2 text-neutral-700">If <b>{email}</b> is on our system, you'll get a reset link in a minute. The link expires in 30 minutes.</p>
            <p className="mt-3 text-neutral-500 text-sm">Didn't get it? Check spam, or wait a minute and try again.</p>
            <div className="mt-4 flex gap-3">
              <button onClick={() => { setSent(false); setEmail(""); }} data-testid="try-again" className="font-mono-sl text-xs uppercase underline">Send to another email</button>
            </div>
          </div>
        )}
      </NbCard>
    </Container>
  );
}
